import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParamContext } from '../service/param.context';
import { finalize } from 'rxjs/operators';
import { ListCreationComponent } from './list-creation.component';
import { NgbActiveModal, NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TreeService } from '../tree/tree.service';
import { JhiLanguageService } from '../core-utils';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../alert/alert.service';
import { TreeDragDropService } from 'primeng/api';
import { GermplasmManagerContext } from '../../germplasm-manager/germplasm-manager.context';
import { Principal } from '..';
import { SampleTreeService } from '../../entities/sample/tree-table';
import { ListService } from './service/list.service';
import { SampleListService } from './service/sample-list.service';
import { SampleList } from './model/sample-list';

@Component({
    selector: 'jhi-sample-list-creation',
    templateUrl: './list-creation.component.html',
    providers: [
        { provide: TreeService, useClass: SampleTreeService },
        { provide: ListService, useClass: SampleListService }
    ]
})
export class SampleListCreationComponent extends ListCreationComponent {

    _isLoading: boolean;
    sampleList: SampleList;

    constructor(
        public modal: NgbActiveModal,
        public jhiLanguageService: JhiLanguageService,
        public translateService: TranslateService,
        public alertService: AlertService,
        public paramContext: ParamContext,
        public treeService: TreeService,
        public treeDragDropService: TreeDragDropService,
        public listService: ListService,
        public germplasmManagerContext: GermplasmManagerContext,
        public calendar: NgbCalendar,
        public modalService: NgbModal,
        public principal: Principal,
        public http: HttpClient,
        public context: ParamContext,
    ) {
        super(
            modal,
            jhiLanguageService,
            translateService,
            alertService,
            paramContext,
            treeService,
            treeDragDropService,
            listService,
            germplasmManagerContext,
            calendar,
            modalService,
            principal,
        );
    }

    save() {

        if (this.sampleList) {
            this.sampleList.listName = this.model.listName;
            this.sampleList.createdDate = `${this.creationDate.year}-${this.creationDate.month}-${this.creationDate.day}`;
            this.sampleList.description = this.model.description;
            this.sampleList.notes = this.model.notes;
            this.sampleList.parentId = (this.selectedNodes[0].data.id !== 'LISTS') ? this.selectedNodes[0].data.id : 1;
            this._isLoading = true;
            this.subscriptionManager.add = this.listService.save(this.sampleList)
                .pipe(finalize(() => {
                    this._isLoading = false;
                })).subscribe(
                    (res) => {
                        this.alertService.success('study-editor.genotyping-samples.create-genotyping-samples-modal.creation-list-success');
                        this.modal.close(res);
                    }
                );

        }

    }

    get isLoading() {
        return this._isLoading;
    }

}
